export default __webpack_public_path__ + "static/media/logoBillgate.6ecdef43.png";